import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=0805078a&scoped=true"
import script from "./MessageTemplates.vue?vue&type=script&lang=js"
export * from "./MessageTemplates.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=0805078a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805078a",
  null
  
)

export default component.exports